import { Route, Routes } from 'react-router-dom';
import { SessionKeepAlive } from './components/SessionKeepAlive';
import AdminPage from './pages/AdminPage';
import UserHomePage from './pages/UserHomePage';
import UserLoginPage from './pages/UserLoginPage';
import UserSettingsPage from './pages/UserSettingsPage';
import WalletDetailPage from './pages/WalletDetailPage';
import SwapPage from './pages/SwapPage';
import TokenDetailPage from './pages/TokenDetailPage';
import TransferPage from './pages/TransferPage';
import ProxyTransferPage from './pages/ProxyTransferPage';

export default function App() {
  return (
    <>
      <SessionKeepAlive />
      <Routes>
        <Route path="/" element={<UserLoginPage />} />
        <Route path="/home" element={<UserHomePage />} />
        <Route path="/home/swap" element={<SwapPage />} />
        <Route path="/home/transfer" element={<TransferPage />} />
        <Route path="/home/proxy-transfer" element={<ProxyTransferPage />} />
        <Route path="/home/settings" element={<UserSettingsPage />} />
        <Route path="/home/wallet/:id" element={<WalletDetailPage />} />
        <Route path="/home/wallet/:id/token/:chain/:tokenRef" element={<TokenDetailPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
    </>
  );
}
